import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq18',
  templateUrl: './cq18.component.html',
  styleUrls: ['./cq18.component.css' , '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq18Component implements OnInit {

  special_contracts;
  @Input() data: any;
  isDisable;
  showTip = false;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  messagetype;
  hgContracts = {
    use1: false,
    use2: false,
    use3: false,
    use4: false
  };
  deviceWidth;
  user_bot;
  time = 1000;
  use1_id;
  use2_id;
  use3_id;
  use4_id;
  showTyping = false;
  timer;
  typingTimer;
  question_sub1;
  question_sub2;
  isChecked = false;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
   }


  ngOnInit() {
  this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.use1_id = document.getElementById('use1_mob');
      this.use2_id = document.getElementById('use2_mob');
      this.use3_id = document.getElementById('use3_mob');
      this.use4_id = document.getElementById('use4_mob');
    } else {
      this.use1_id = document.getElementById('use1');
      this.use2_id = document.getElementById('use2');
      this.use3_id = document.getElementById('use3');
      this.use4_id = document.getElementById('use4');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
        if(this.deviceWidth > 768) {
          const question_sub1 = this.question.split('contract ');
          this.question_sub1 = question_sub1[0] + 'contract';
          this.question_sub2 = question_sub1[1];
        } 
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.special_contracts = obj.fieldValue;
        if (!_.isEmpty(this.special_contracts)) {
          this.user_bot = true;
          if (this.special_contracts === 'Separate contracts for each location') {
            this.hgContracts = {
              use1: true,
              use2: false,
              use3: false,
              use4: false
            };
            this.use1_id.parentElement.classList.add('active-select');
          } else if (this.special_contracts === 'Separate invoices for each location') {
            this.hgContracts = {
              use1: false,
              use2: true,
              use3: false,
              use4: false
            };
            this.use2_id.parentElement.classList.add('active-select');
          } else if (this.special_contracts === 'Single contract for all locations') {
            this.hgContracts = {
              use1: false,
              use2: false,
              use3: true,
              use4: false
            };
            this.use3_id.parentElement.classList.add('active-select');
          } else if (this.special_contracts === 'Consolidated billing') {
            this.hgContracts = {
              use1: false,
              use2: false,
              use3: false,
              use4: true
            };
            this.use4_id.parentElement.classList.add('active-select');
          }
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }
  }

  getSpecial_contracts(event) {
    this.special_contracts = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        // // console.log.log(this.deviceWidth);
        this.commercialService.unSelectService({'currentId': this.data});
      }
      if (!_.isEmpty(this.special_contracts)) {
        this.user_bot = true;
        if (this.special_contracts === 'Separate contracts for each location') {
          this.hgContracts = {
            use1: true,
            use2: false,
            use3: false,
            use4: false
          };
          if (_.contains(this.use2_id.parentElement.classList, 'active-select')) {
            this.use2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use3_id.parentElement.classList, 'active-select')) {
            this.use3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use4_id.parentElement.classList, 'active-select')) {
            this.use4_id.parentElement.classList.remove('active-select');
          }
          this.use1_id.parentElement.classList.add('active-select');
        } else if (this.special_contracts === 'Separate invoices for each location') {
          this.hgContracts = {
            use1: false,
            use2: true,
            use3: false,
            use4: false
          };
          this.use2_id.parentElement.classList.add('active-select');
          if (_.contains(this.use1_id.parentElement.classList, 'active-select')) {
            this.use1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use3_id.parentElement.classList, 'active-select')) {
            this.use3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use4_id.parentElement.classList, 'active-select')) {
            this.use4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.special_contracts === 'Single contract for all locations') {
          this.hgContracts = {
            use1: false,
            use2: false,
            use3: true,
            use4: false
          };
          this.use3_id.parentElement.classList.add('active-select');
          if (_.contains(this.use1_id.parentElement.classList, 'active-select')) {
            this.use1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use2_id.parentElement.classList, 'active-select')) {
            this.use2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use4_id.parentElement.classList, 'active-select')) {
            this.use4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.special_contracts === 'Consolidated billing') {
          this.hgContracts = {
            use1: false,
            use2: false,
            use3: false,
            use4: true
          };
          this.use4_id.parentElement.classList.add('active-select');
          if (_.contains(this.use1_id.parentElement.classList, 'active-select')) {
            this.use1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use2_id.parentElement.classList, 'active-select')) {
            this.use2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.use3_id.parentElement.classList, 'active-select')) {
            this.use3_id.parentElement.classList.remove('active-select');
          }
        }
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.hgContracts = {
        use1: false,
        use2: false,
        use3: false,
        use4: false
      };
      if (_.contains(this.use1_id.parentElement.classList, 'active-select')) {
        this.use1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.use2_id.parentElement.classList, 'active-select')) {
        this.use2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.use3_id.parentElement.classList, 'active-select')) {
        this.use3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.use4_id.parentElement.classList, 'active-select')) {
        this.use4_id.parentElement.classList.remove('active-select');
      }
      this.special_contracts = '';
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      this.user_bot = false;
    }
    this.save();
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, this.time);
      this.showTyping =  false;
    }
  }

  next() {
    if (_.isEmpty(this.special_contracts)) {
      // // console.log.log(this.special_contracts);
      // alert('Select atleast one special_contracts.');
      this.commercialService.unSelectService({'currentId': this.data});
    } else {
      this.save();
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'special_contracts', 'fieldValue': this.special_contracts
    };
    this.commercialService.updateResponses(Obj);
  }
}
